module.exports = __webpack_public_path__ + "static/pineapple-organic-888391f9ff689541bf69abe5f1c615ca.jpg";